module.exports = __webpack_public_path__ + "static/the-dip-2ee2668976edc2842d549e5ac5d4f413.jpg";